import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyC17pdSvUzToWMh0GIUndyPTR0X_UhBB7E",
  authDomain: "nexia-digital.firebaseapp.com",
  projectId: "nexia-digital",
  storageBucket: "nexia-digital.firebasestorage.app",
  messagingSenderId: "577251477301",
  appId: "1:577251477301:web:47a7477678377bbcdb2e7c"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);

/**
 * Secondary Firebase app — used to create new user accounts from the admin panel
 * without signing in as them on the main app. The admin's session stays intact.
 */
const secondaryApp = initializeApp(firebaseConfig, 'Secondary');
export const secondaryAuth = getAuth(secondaryApp);

export default app;
